const BASE_API_URL = process.env.REACT_APP_BASE_API_URL || "";

const BASE_CMS_API_URL = process.env.REACT_APP_BASE_CMS_API_URL || "";

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

const BRANCH_KEY = process.env.REACT_APP_BRANCH_KEY || "";

const ONE_SIGNAL_KEY = process.env.REACT_APP_ONE_SIGNAL_KEY || "";

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";

const CURRENT_VERSION = '04.11.26';

const AIRLINE_BRAND_IMAGE = (countryCode) =>
    countryCode &&
    `https://geniustravel-prod.azureedge.net/Airlines/th_${countryCode?.toLowerCase()}_tx.png`;

const iOSAppStoreLink = "https://apps.apple.com/us/app/genius-ai-travel-assistant/id1661100442";
const AndroidPlayStoreLink = "https://play.google.com/store/apps/details?id=com.appelit.geniustravel";

const MIN_PRICE = 0;
const MAX_PRICE = 2500;
// A stay without a flight is a different budget: the chat's price step runs to this
// instead of MAX_PRICE when the conversation is Stay only. Everything else keeps
// MAX_PRICE. It is independent of MAX_PRICE and may sit either side of it.
const MAX_PRICE_STAY_ONLY = 1000;

const MIN_STAR_RATING = 0;
const MAX_STAR_RATING = 5;

const _TILE_VALUES = (mini, maxi) => {
    const min = Number(mini);
    const max = Number(maxi);

    let wholeNumber = 0,
        diff = 0;

    if (min !== 0) {
        diff = ((max - min) / 20).toFixed(0);
    } else {
        wholeNumber = (max / 20).toFixed(0);
    }

    return [
        { height: 5 },
        { height: 5 },
        { height: 12 },
        { height: 10 },
        { height: 13 },
        { height: 15 },
        { height: 21 },
        { height: 31 },
        { height: 33 },
        { height: 33 },
        { height: 31 },
        { height: 28 },
        { height: 30 },
        { height: 35 },
        { height: 40 },
        { height: 49 },
        { height: 45 },
        { height: 35 },
        { height: 10 },
        { height: 5 },
    ].map((tile, index) => {
        return {
            ...tile,
            value:
                min === 0
                    ? wholeNumber * (index + 1)
                    : Number((min + diff * index).toFixed()),
        };
    });
};

const _ROOM_EXTRA_SERVICE = [
    { id: 1, service: "No extras", price: "+ €0", isChecked: false },
    { id: 2, service: "Breakfast", price: "+ €10", isChecked: false },
];

// Todo: Currency change revert to normal. Uncomment USD here, then revert the other
// places with this Todo (TranslationProvider, getCurrencyBadge).
const CURRENCIES = [
    { code: "EUR", name: "Euro", symbol: "€" },
    // { code: "USD", name: "Dollar", symbol: "$" },
    // {code: "GBP", name: "Pound", symbol: "£"},
];

const _APP_LANGUAGES = [
    {
        id: 0,
        country: "Nederland",
        code: "nl_NL",
        name: "Nederlands",
        short: "Nl",
    },
    {
        id: 1,
        country: "Engels",
        code: "en_US",
        name: "English (US)",
        short: "En",
    },
];

const _DEPARTIRE_DATE = [
    { id: 1, text: "± 1 days", key: "departure_date" },
    { id: 2, text: "± 2 days", key: "departure_date" },
    { id: 3, text: "± 3 days", key: "departure_date" },
];

const _GUEST_RATING = [
    { id: 1, key: "guest_rating", text: "⭐", icon: true },
    { id: 2, key: "guest_rating", text: "⭐ ⭐", icon: true },
    { id: 3, key: "guest_rating", text: "⭐ ⭐ ⭐", icon: true },
    { id: 4, key: "guest_rating", text: "⭐ ⭐ ⭐ ⭐", icon: true },
    { id: 5, key: "guest_rating", text: "⭐ ⭐ ⭐ ⭐ ⭐", icon: true },
];

const _STEPS = [
    { id: 0, key: "steps", text: "Direct" },
    { id: 1, key: "steps", text: "1 stop" },
    { id: 2, key: "steps", text: "2+ stops" },
];

const _DEPARTURE_TIME = [
    { id: 1, key: "departure_time", text: "Anytime" },
    {
        id: 2,
        key: "departure_time",
        text: "Morning (06:30 - 12:00)",
        StartTime: "06:30:00",
        EndTime: "12:00:00",
    },
    {
        id: 3,
        key: "departure_time",
        text: "Afternoon (12:00 - 18:00)",
        StartTime: "12:00:00",
        EndTime: "18:00:00",
    },
    {
        id: 4,
        key: "departure_time",
        text: "Night (18:00 - 00:00)",
        StartTime: "18:00:00",
        EndTime: "00:00:00",
    },
];

const _ARRIVAL_TIME = [
    { id: 1, key: "arrival_time", text: "Anytime" },
    {
        id: 2,
        key: "arrival_time",
        text: "Morning (06:30 - 12:00)",
        StartTime: "06:30:00",
        EndTime: "12:00:00",
    },
    {
        id: 3,
        key: "arrival_time",
        text: "Afternoon (12:00 - 18:00)",
        StartTime: "12:00:00",
        EndTime: "18:00:00",
    },
    {
        id: 4,
        key: "arrival_time",
        text: "Night (18:00 - 00:00)",
        StartTime: "18:00:00",
        EndTime: "00:00:00",
    },
];

const _AIRLINE_CLASSES = [
    { id: 1, key: "airline_class", text: "ECONOMY", value: "ECONOMY" },
    { id: 2, key: "airline_class", text: "BUSINESS", value: "BUSINESS" },
    {
        id: 3,
        key: "airline_class",
        text: "PREMIUM ECONOMY",
        value: "PREMIUMECONOMY",
    },
    { id: 4, key: "airline_class", text: "FIRST", value: "FIRST" },
];

const AppConfig = {
    baseApiURL: BASE_API_URL,
    baseCMSApiURL: BASE_CMS_API_URL,
    branchKey: BRANCH_KEY,
    googleMapAPIKey: GOOGLE_MAPS_API_KEY,
    oneSignalKey: ONE_SIGNAL_KEY,
    gaMeasurementID: GA_MEASUREMENT_ID,
    webVersion: CURRENT_VERSION,
    appLanguages: _APP_LANGUAGES,
    tileValues: _TILE_VALUES,
    fakeRoomExtraService: _ROOM_EXTRA_SERVICE,
    departureDate: _DEPARTIRE_DATE,
    guestRating: _GUEST_RATING,
    departureTime: _DEPARTURE_TIME,
    arrivalTime: _ARRIVAL_TIME,
    steps: _STEPS,
    airlineClasses: _AIRLINE_CLASSES,
    minPrice: MIN_PRICE,
    maxPrice: MAX_PRICE,
    maxPriceStayOnly: MAX_PRICE_STAY_ONLY,
    minStarRating: MIN_STAR_RATING,
    maxStarRating: MAX_STAR_RATING,
    getAirlineImageURL: AIRLINE_BRAND_IMAGE,
    currencies: CURRENCIES,
    iOSAppStoreLink: iOSAppStoreLink,
    AndroidPlayStoreLink: AndroidPlayStoreLink,
};

export default AppConfig;
